export default __webpack_public_path__ + "static/platform-dcbbf8d7f6745e507823155c7577c703.webp";